import SearchIcon from '@mui/icons-material/Search'
import { Button, Grid, MenuItem, TextField } from '@mui/material'
import dayjs from 'dayjs'

import DateRangePicker from '../../../../../components/DateRangePicker'
import { DATE_FORMAT_INTERNATIONAL } from '../../../../../constants/global'
import { ITikTokAccount } from '../../../../../types/tiktok'
import { getStatusLabel } from '../constants'
import { IReportFilter } from '../types'

interface FilterProps {
  tiktokAccounts: ITikTokAccount[]
  filter: IReportFilter
  statusFilter: string
  statusOptions: string[]
  showStatus?: boolean
  onFilterChange: (filter: IReportFilter) => void
  onStatusChange: (status: string) => void
  onSearch: (filter: IReportFilter) => void
}

const ReportFilter = (props: FilterProps) => {
  const {
    tiktokAccounts = [],
    filter,
    statusFilter,
    statusOptions,
    showStatus = true,
    onFilterChange,
    onStatusChange,
    onSearch,
  } = props

  const handleDateChange = (startDate?: string, endDate?: string) => {
    onFilterChange({
      ...filter,
      startDate: startDate
        ? dayjs(startDate).format(DATE_FORMAT_INTERNATIONAL)
        : undefined,
      endDate: endDate
        ? dayjs(endDate).format(DATE_FORMAT_INTERNATIONAL)
        : undefined,
    })
  }

  return (
    <Grid container spacing={1} mb={2}>
      <Grid item xs={12} lg={3}>
        <TextField
          select
          fullWidth
          label="บัญชี"
          value={filter.shopId || ''}
          SelectProps={{ displayEmpty: true }}
          InputLabelProps={{ shrink: true }}
          onChange={(e) =>
            onFilterChange({
              ...filter,
              shopId: e.target.value || undefined,
            })
          }
        >
          <MenuItem value="">ทุกร้านค้า</MenuItem>
          {tiktokAccounts.map((account) => (
            <MenuItem key={account.shopId} value={account.shopId}>
              {account.sellerName}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {showStatus && (
        <Grid item xs={12} lg={2}>
          <TextField
            select
            fullWidth
            label="สถานะ"
            value={statusFilter}
            SelectProps={{ displayEmpty: true }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => onStatusChange(e.target.value)}
          >
            <MenuItem value="">ทั้งหมด</MenuItem>
            {statusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                {getStatusLabel(status)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      )}
      <Grid item xs={12} lg={showStatus ? 4 : 6}>
        <DateRangePicker
          gap={1}
          disableFuture
          startDate={filter.startDate}
          endDate={filter.endDate}
          onChange={handleDateChange}
        />
      </Grid>
      <Grid item xs={12} lg={3}>
        <Button
          color="primary"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
    </Grid>
  )
}

export default ReportFilter
